<ng-container *ngIf="columns.size">
   <mat-divider></mat-divider>

   <div class="wrapper">
      <header [attr.color]="valid ? '' : 'warn'">fields *</header>

      <mat-tab-group dynamicHeight mat-align-tabs="center" mat-stretch-tabs="always" class="noselect">
         <mat-tab #availableTab>
            <ng-template mat-tab-label>
               {{columns.size - fields.length}} Available
            </ng-template>

            <mat-form-field *ngIf="columns.size" class="column-search">
               <mat-icon matPrefix>search</mat-icon>
               <mat-label>Search Columns</mat-label>
               <input matInput [formControl]="filter" (keyup.escape)="filter.reset()" />

               <button mat-icon-button matSuffix color="warn" (click)="filter.reset()" *ngIf="filter.value">
                  <mat-icon>close</mat-icon>
               </button>
            </mat-form-field>

            <ng-container *ngIf="available$ | async as available">
               <ng-container *ngFor="let column of available | slice: start : end; index as i">
                  <button mat-stroked-button class="available-button" (click)="add( column )" >
                     <mat-icon class="common-mr1em">add</mat-icon>
                     {{column.header}}
                  </button>
               </ng-container>
            

               <mat-paginator
                  #paginator
                  *ngIf="(available$ | async).length"
                  [length]="(available$ | async).length"
                  pageSize="pageSize"
                  [pageSizeOptions]="[10,30,50,100]"
                  (page)="page = $event.pageIndex; pageSize = $event.pageSize"
               ></mat-paginator>
            </ng-container>
         </mat-tab>

         <mat-tab #addedTab>
            <ng-template mat-tab-label>
               {{fields.length}} Added
            </ng-template>

            <div class="column-box" *ngIf="!fields.length">
               <div class="common-pad1em common-mauto">No Added Columns</div>
            </div>

            <div cdkDropList (cdkDropListDropped)="drop($event)" *ngIf="fields.length">
               <div cdkDrag *ngFor="let field of fields.controls; index as i" class="column-box clickable">
                  <ng-template cdkDragPlaceholder>
                     <div class="fields-placeholder"></div>
                  </ng-template>

                  <ng-container>
                     <div class="common-fg1">
                        <mat-icon class="common-mr1em">drag_handle</mat-icon>

                        <mat-form-field floatLabel="never" class="fields-field">
                           <mat-label>{{columns.get( field.get( 'name' ).value )?.header}}</mat-label>
                           <input matInput class="form-control" [formControl]="field.get('header')" />
                        </mat-form-field>
                     </div>

                     <div>
                        <div *ngIf="!hasPrimarySort()">
                           <button mat-stroked-button class="sort" (click)="field.get( 'sort_ord' ).setValue( 1 ); field.get( 'sort_dir' ).setValue( 'desc' )">Add Sort</button>
                        </div>

                        <div *ngIf="field.get( 'sort_ord' ).value">
                           <button mat-raised-button class="sort" color="primary" (click)="field.get( 'sort_ord' ).setValue( null )" class="fields-sortbutton">
                              Primary Sort
                           </button>

                           <ng-container *ngIf="field.get( 'sort_dir' ) as sort_dir">
                              <button mat-raised-button class="sort" color="primary" (click)="sort_dir.setValue( sort_dir.value == 'asc' ? 'desc' : 'asc' )" [matTooltip]="sort_dir.value == 'asc' ? 'Ascending' : 'Descending'" class="fields-primsort">
                                 <mat-icon [class.flip]="sort_dir.value == 'asc'">sort</mat-icon>
                              </button>
                           </ng-container>
                        </div>

                        <!-- <div *ngIf="false"> -->
                           <!-- Multiple Sort Buttons -->
                           <!-- <button mat-raised-button class="sort" [color]="field.sort_ord == 1 ? 'primary' : field.sort_ord == 2 ? 'accent' : 'basic'" (click)="toggleColumn( column )" [ngStyle]="field.sort_ord && { 'border-radius': '4px 0 0 4px' }">
                              {{field.sort_ord == 1 ? 'Primary' : field.sort_ord == 2 ? 'Secondary' : field.sort_ord == 3 ? 'Ternary' : 'Add' }} Sort
                           </button>
                           <button mat-raised-button *ngIf="field.sort_ord" class="sort" [color]="field.sort_ord == 1 ? 'primary' : field.sort_ord == 2 ? 'accent' : 'basic'" (click)="field.sort_dir = ( field.sort_dir == 'asc' ? 'desc' : 'asc' )" [matTooltip]="field.sort_dir == 'asc' ? 'Ascending' : 'Descending'" class="fields-primsort">
                              <mat-icon [class.flip]="field.sort_dir == 'asc'">sort</mat-icon>
                           </button> -->
                        <!-- </div> -->

                        <button mat-icon-button color="warn" (click)="fields.removeAt( i )">
                           <mat-icon>clear</mat-icon>
                        </button>
                     </div>
                  </ng-container>
               </div>
            </div>
         </mat-tab>
      </mat-tab-group>
   </div>
</ng-container>
